import { HttpClientModule } from '@angular/common/http';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { AppSettingsService } from '../../shared/services/appsettings.service';
import { AuthModule } from '../authModule/auth.module';
import { AuthGuard } from '../authModule/services/auth-guard.service';
import { AuthenticationService } from '../authModule/services/authentication.service';
import { GalleryModule } from '../galleryModule/gallery.module';
import { GalleryRouting } from '../galleryModule/gallery.routing';
import { VoteService } from '../galleryModule/services/vote.service';
import { MatComponentsModule } from '../mat-components.module';
import { AboutContestComponent } from './components/about-contest/about-contest.component';
import { AppServicesComponent } from './components/app-services/app-services.component';
import { AppComponent } from './components/app.component';
import { ContestIntroduction } from './components/contest-introduction/contest-introduction.component';
import { ContestWinnersComponent } from './components/contest-winners/contest-winners.component';
import { FooterComponent } from './components/footer/footer.component';
import { HomeComponent } from './components/home/home.component';
import { NavMenuComponent } from './components/nav-menu/nav-menu.component';
import { TestimonialsComponent } from './components/testimonials/testimonials.component';
import { VirtualGalleryComponent } from './components/virtual-gallery/virtual-gallery.component';
import { WelcomeComponent } from './components/welcome/welcome.component';

export function initializeApp(appSettingsService: AppSettingsService) {
  return () => appSettingsService.load();
}

@NgModule({
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,
    WelcomeComponent,
    FooterComponent,
    ContestIntroduction,
    AboutContestComponent,
    AppServicesComponent,
    ContestWinnersComponent,
    TestimonialsComponent,
    VirtualGalleryComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule.forRoot([
      {
        path: '',
        component: HomeComponent,
      }
    ],
      { relativeLinkResolution: 'legacy' }),
    BrowserAnimationsModule,
    CarouselModule,
    MatComponentsModule,
    GalleryModule,
    AuthModule,
    GalleryRouting,
    FontAwesomeModule,
    NgxPageScrollCoreModule,
    NgxPageScrollModule
  ],
  providers: [
    AppSettingsService,
    VoteService,
    AuthenticationService,
    AuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppSettingsService],
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }
